import { ZealApiSuccessResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import type {
  TPostAiConversationRequestSchema,
  TPostAiConversationResponseSchema,
} from "./postAiConversation.schema";

type TSuccess = ZealApiSuccessResponse<TPostAiConversationResponseSchema>;

export const postAiConversation = (axios: IAxiosInstance) => {
  return async (
    params: TPostAiConversationRequestSchema
  ): Promise<TPostAiConversationResponseSchema> => {
    try {
      const response = await axios.noRetry.post<TSuccess>(
        "/api/ai/conversations",
        params
      );
      const body = response.data;
      if (body?.success === true) {
        return body.data;
      }
      throw new ZealClientError(response);
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
